import { createRoot } from "react-dom/client";
import { PostHogProvider } from '@posthog/react';
import App from "./App.tsx";
import "./index.css";
import "./lib/i18n"; // Initialize i18n

const options = {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
    enable_recording_console_log: true,
    // Enable debug in dev
    loaded: (posthog) => {
        if (import.meta.env.DEV) posthog.debug()
    }
}

createRoot(document.getElementById("root")!).render(
    <PostHogProvider
        apiKey={import.meta.env.VITE_POSTHOG_KEY}
        options={options}
    >
        <App />
    </PostHogProvider>
);
